import { render, staticRenderFns } from "./FlashFixParcel.vue?vue&type=template&id=354cf0ea"
import script from "./FlashFixParcel.vue?vue&type=script&lang=js"
export * from "./FlashFixParcel.vue?vue&type=script&lang=js"
import style0 from "./FlashFixParcel.vue?vue&type=style&index=0&id=354cf0ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports